"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumHTMLBody = void 0;
const typebox_1 = require("@sinclair/typebox");
// d-0c00d9057705419e97c271061c909e7b
exports.SourgumHTMLBody = typebox_1.Type.Object({
    subject: typebox_1.Type.String(),
    body: typebox_1.Type.String(),
});
//# sourceMappingURL=sourgum-html-body.js.map